import { prepHandleEvent } from "./prepHandleEvent";
export function handleResize(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;

  myApp.HandleResize(event);
}
